var _has = require('./_has');


module.exports = (function() {
  var toString = Object.prototype.toString;
  return toString.call(arguments) === '[object Arguments]' ?
    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
    function _isArguments(x) { return _has('callee', x); };
}());



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isArguments.js
// module id = 180
// module chunks = 35783957827783 114276838955818